import cn from 'classnames';
import { Label } from '#components/atoms/forms/index.ts';
import styles from './Checkbox.module.css';

type Props = React.ComponentPropsWithRef<'input'> & {
  className?: string;
  hasError?: boolean;
  label?: React.ReactNode;
};

export function Checkbox({ hasError, className, label, disabled, ...htmlProps }: Props) {
  return (
    <Label
      className={cn(styles.Checkbox, className, {
        [styles.Checkbox___hasError]: hasError,
        [styles.Checkbox___disabled]: disabled,
      })}
    >
      <input className={styles.Checkbox_input} type="checkbox" disabled={disabled} {...htmlProps} />
      {label}
    </Label>
  );
}
